import Vue from 'vue'
import Router from 'vue-router'
import Emotions from './components/Emotions'
import Postform from './components/Form'

Vue.use(Router)

export default new Router({
    mode:'history',
    routes:[
        {
            path:'/emotions',
            name:'emotions',
            component:Emotions
        },
        {
            path:'/form',
            name:'form',
            component:Postform
        }
    ]

})